module.exports = __webpack_public_path__ + "static/img/13.b3c5679a.jpg";